import React from 'react'

import type { RecipeQueryResponse } from '@library/api-menu-experience'

import { RecipeAttributePill } from 'routes/Menu/components/RecipeAttributePill/RecipeAttributePill'

import { getTagPillIcon } from './getTagPillIcon'

type TagPillProps = {
  type?: string
  text: string
  displayType?: RecipeQueryResponse['displayType']
}

export const TagPill = ({ type, text, displayType }: TagPillProps) => {
  const pillIcon = getTagPillIcon(type, displayType)

  if (!pillIcon) {
    return null
  }

  if (pillIcon.variant === 'local') {
    return <RecipeAttributePill variant="local" localIcon={pillIcon.localIcon} text={text} />
  }

  return <RecipeAttributePill icon={pillIcon.icon} text={text} />
}
